// extracted by mini-css-extract-plugin
export default {"bvn_card":"style_bvn_card__yZSHn"};